import React from 'react'
import PropTypes from 'prop-types'

import AspectRatioImage from 'src/ui/AspectRatioImage/AspectRatioImage'
import CardInfo from 'src/ui/Card/subcomponents/CardInfo'

import HeroCardSkeleton from './HeroCardSkeleton'
import HeroCardReference from './subcomponents/HeroCardReference/HeroCardReference'

const HeroCard = ({
  imgUrl,
  title,
  subtitle,
  description,
  aspectRatio,
  label,
  footer,
  reference,
}) => {
  return (
    <HeroCardSkeleton
      imageSection={
        <AspectRatioImage
          imgUrl={imgUrl}
          aspectRatio={aspectRatio}
          borderRadius="1x"
        />
      }
      infoSection={
        <CardInfo
          title={title}
          subtitle={subtitle}
          description={description}
          label={label}
        />
      }
      infoFooterSection={footer}
      referenceSection={reference && <HeroCardReference {...reference} />}
    />
  )
}

HeroCard.propTypes = {
  imgUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  aspectRatio: PropTypes.string,
  label: PropTypes.any,
  footer: PropTypes.any,
  reference: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    linkUrl: PropTypes.string.isRequired,
  }),
}

export default HeroCard
